import Icon from './Icon';

/**
 * Card wrapper. Header has icon + title + subtitle + optional badge slot
 * + optional action slot. Body has 24px padding. NO overflow: hidden so
 * picker dropdowns escape (per prototype chat 1 fix).
 *
 * @param {{
 *   icon?: string,
 *   title: string,
 *   subtitle?: string,
 *   badge?: any,
 *   action?: any,
 *   children?: any,
 * }} props
 */
export default function Section({ icon, title, subtitle, badge, action, children }) {
  return (
    <section
      style={{
        background: 'var(--ab-bg)',
        border: 'var(--ab-hairline)',
        borderRadius: 'var(--ab-radius-md)',
        marginBottom: 24,
        // overflow: visible — DO NOT add overflow:hidden.
      }}
    >
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '16px 24px',
          borderBottom: '1px solid var(--ab-border-hair)',
        }}
      >
        {icon && <Icon name={icon} size={18} />}
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: 'var(--ab-text-h4)',
            fontWeight: 'var(--ab-weight-semi)',
            color: 'var(--ab-fg)',
          }}>
            {title}
          </div>
          {subtitle && (
            <div style={{
              fontSize: 'var(--ab-text-xs)',
              color: 'var(--ab-fg-subtle)',
              marginTop: 2,
            }}>
              {subtitle}
            </div>
          )}
        </div>
        {badge}
        {action}
      </header>
      <div style={{ padding: 24 }}>{children}</div>
    </section>
  );
}
